let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4cWYg")).then(() => parcelRequire('cC6lI'));